import '@buy-viasat/utils';

function clientLogger(message: string, error: unknown, env = process.env.NODE_ENV) {
  if (env !== 'production') {
    console.log(message, error);
    return;
  }

  // Datadog RUM is loaded via a CDN snippet (see public/index.html) and may not have finished
  // loading yet, or may be disabled (non-prod build, missing tokens) — both are safe to skip.
  window.DD_RUM?.addError?.(error, { message });
}

export default clientLogger;
